import { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import { theme } from "../../../theme";
import { GenericFieldsView, GenericList } from "../../../components";
import { BiChevronRight } from "react-icons/bi";
import { dataType } from "../../../components/GenericList/GenericList";
import FdTypography from "../../../components/UIComponents/Typography/FdTypography";
import FdButton from "../../../components/UIComponents/Button/FdButton";
import {importDataList as classes} from "../styles"

export type IProps = {
  csvFieldsMatch: any; // the fields match after csv mapping step
  csvType: dataType;
  csvData: any[]; // the imported csv data array
  onValidateData: Function; // callback when data is valid, go next
  onRejectData: Function; // callback when bad data was imported, go back
};

type rowData = {
  [index: string]: string;
};



const ImportedDataList = ({
  csvFieldsMatch,
  csvType,
  csvData,
  onValidateData,
  onRejectData,
}: IProps) => {
  const [selectedDataItem, setSelectedDataItem] = useState();
  const [mappedData, setMappedData] = useState<any>();
 

  useEffect(() => {
    const mappedRowData = getMappedRowData(); // we apply csv values to our csv map;
    setMappedData(mappedRowData);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSelectDataItem = (dataItem: any) => {
    setSelectedDataItem(dataItem);
  };

  const handleDataValidation = () => {
    onValidateData();
  };

  const handleIssueButton = () => {
    onRejectData();
  };

  // function to map csv values to our standard fields
  const getMappedRowData = () => {
    return csvData.map((rowData) => {
      const mappedRowData: rowData = {};
      Object.keys(csvFieldsMatch).forEach((key) => {
        mappedRowData[key.charAt(0).toLowerCase() + key.slice(1)] =
          rowData[csvFieldsMatch[key]];
      });
      return mappedRowData;
    });
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      textAlign="center"
      width="90%"
      margin="0 auto"
      height="calc(100vh - 108px)"
    >
      <FdTypography label={
`${csvType === dataType.ATTENDEES
  ? "Attendees"
  : csvType === dataType.SESSIONS
  ? "Sessions"
  : "Users"} ${" "}
list import`
      } variant="h2" component="h2" sx={{ marginBottom: "20px" }} />

      {/* // show the csv data */}

      <FdTypography label={<>
        Here is the list of your imported{" "}
        {csvType === dataType.ATTENDEES
          ? "attendees"
          : csvType === dataType.SESSIONS
          ? "sessions"
          : "users"}
        . Click on one of them if you would <br /> like to check if their info
        is imported in correctly.
      </>} sx={{ marginBottom: "25px" }} />

      {mappedData && (
        <Box
          position="relative"
          width="100%"
          flexGrow="1"
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          overflow="auto"
        >
          <GenericList
            items={mappedData}
            onSelectItem={onSelectDataItem}
            type={csvType}
            selectedItem={selectedDataItem || mappedData[0]}
          />

          <BiChevronRight size="50" color={theme.palette.grey["800"]} />
          <GenericFieldsView
            csvType={csvType}
            csvMap={csvFieldsMatch}
            item={selectedDataItem || mappedData[0]}
          />
        </Box>
      )}

      <FdButton
        variant="contained"
        color="primary"
        size="medium"
        onClick={handleDataValidation}
        style={{ marginTop: "20px", marginBottom: "10px" }}
        ButtonName="Looks good"
      />

      <FdButton variant="text" sx={classes.issueButton} onClick={handleIssueButton} ButtonName="Go back" />
    </Box>
  );
};

export default ImportedDataList;
